import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type WonderFragment = {
  __typename?: 'Wonder';
  id: string;
  showComments?: boolean | null;
  pnrr?: boolean | null;
  originalLanguage?: string | null;
  sharrySelection?: Types.SharrySelection | null;
  featuredAt?: any | null;
  showMaps?: boolean | null;
  address?: string | null;
  audio?: string | null;
  audioDuration?: number | null;
  audioText?: string | null;
  audioSignature?: string | null;
  bookingNotes?: string | null;
  contentType?: string | null;
  hasCustomCover?: boolean | null;
  createdAt?: any | null;
  directions?: string | null;
  elevation?: number | null;
  email?: string | null;
  estimatedDuration?: string | null;
  facebook?: string | null;
  genericContact?: string | null;
  instagram?: string | null;
  whatsapp?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  notes?: string | null;
  openingTime?: string | null;
  paymentNotes?: string | null;
  promoted?: boolean | null;
  requiresBooking?: boolean | null;
  requiresPayment?: boolean | null;
  region?: string | null;
  province?: string | null;
  municipality?: string | null;
  shortProvince?: string | null;
  customProvince?: string | null;
  searchableAddress?: string | null;
  shortAddress?: string | null;
  slug?: string | null;
  subtitle?: string | null;
  showCustomCarousels?: boolean | null;
  showRelatedCarousels?: boolean | null;
  wonderRelatedCarousel?: boolean | null;
  sharryRelatedCarousel?: boolean | null;
  eventRelatedCarousel?: boolean | null;
  userRelatedCarousel?: boolean | null;
  showDirections?: boolean | null;
  suggestedTime?: string | null;
  telephone?: string | null;
  title?: string | null;
  updatedAt?: any | null;
  validatorNotes?: string | null;
  website?: string | null;
  isRecommendation?: boolean | null;
  whyItsSpecialForYou?: string | null;
  status: Types.SharryContentStatus;
  publishedAt?: any | null;
  story?: string | null;
  geographicallyExcludedIds?: Array<string> | null;
  totalCherries?: number | null;
  landIds?: Array<string> | null;
  itineraryNew?: { __typename?: 'Itinerary'; id: string } | null;
  metaTag?: { __typename?: 'MetaTag'; id: string; title?: string | null; description?: string | null } | null;
  sharryKind?: {
    __typename?: 'SharryKind';
    id: string;
    name?: string | null;
    nameIt?: string | null;
    nameEn?: string | null;
    contentType?: Types.SharryContentType | null;
  } | null;
  accessibilityCategories?: Array<{
    __typename?: 'SharryContentAccessibilityCategory';
    id: string;
    suitable?: boolean | null;
    notes?: string | null;
    accessibilityCategory: { __typename?: 'AccessibilityCategory'; id?: string | null; name?: string | null };
  }> | null;
  categories?: Array<{
    __typename?: 'Category';
    id?: string | null;
    name?: string | null;
    normalizedName?: string | null;
    sort?: number | null;
    icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  }> | null;
  customCover?: {
    __typename?: 'CustomCover';
    id: string;
    licenseType?: Types.GalleryContentLicenseEnum | null;
    author?: string | null;
    description?: string | null;
    image?: {
      __typename?: 'Image';
      url?: string | null;
      vw480?: string | null;
      vw768?: string | null;
      vw1024?: string | null;
      id?: string | null;
      thumbnail?: string | null;
    } | null;
  } | null;
  coverPicture?: {
    __typename?: 'GalleryImage';
    id?: string | null;
    licenseType?: Types.GalleryContentLicenseEnum | null;
    author?: string | null;
    description?: string | null;
    bestVersion?: {
      __typename?: 'Image';
      url?: string | null;
      vw480?: string | null;
      vw768?: string | null;
      vw1024?: string | null;
      id?: string | null;
      thumbnail?: string | null;
    } | null;
  } | null;
  creator?: {
    __typename?: 'User';
    id: string;
    anonymised?: boolean | null;
    name?: string | null;
    surname?: string | null;
    businessName?: string | null;
    fullname?: string | null;
    email?: string | null;
    isSmallOrganisation?: boolean | null;
    isMe: boolean;
    isProGold?: boolean | null;
    role: Types.UserRole;
    sharrylandPartner: boolean;
    slug?: string | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    myFollow?: { __typename?: 'Follow'; id: string } | null;
    qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
  } | null;
  hashtags?: Array<{ __typename?: 'Hashtag'; id: string; name: string }> | null;
  owner?: {
    __typename?: 'User';
    id: string;
    anonymised?: boolean | null;
    name?: string | null;
    surname?: string | null;
    businessName?: string | null;
    email?: string | null;
    isSmallOrganisation?: boolean | null;
    isMe: boolean;
    isProGold?: boolean | null;
    role: Types.UserRole;
    sharrylandPartner: boolean;
    slug?: string | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    myFollow?: { __typename?: 'Follow'; id: string } | null;
    qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
  } | null;
  myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
  visitDuration?: { __typename?: 'VisitDuration'; id: string; text?: string | null } | null;
  originalRecommendation?: { __typename?: 'Wonder'; id: string; slug?: string | null } | null;
  publisher?: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    isSmallOrganisation?: boolean | null;
    anonymised?: boolean | null;
    businessName?: string | null;
  } | null;
  services?: Array<{ __typename?: 'Service'; id?: string | null; name?: string | null; icon?: string | null }> | null;
  months?: Array<{ __typename?: 'Month'; id?: string | null; name?: string | null }> | null;
  itineraryIndex?: Array<{
    __typename?: 'Wonder';
    id: string;
    slug?: string | null;
    title?: string | null;
    contentType?: string | null;
    sharrySelection?: Types.SharrySelection | null;
    coverPicture?: {
      __typename?: 'GalleryImage';
      id?: string | null;
      bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    } | null;
    myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
    sharryKind?: {
      __typename?: 'SharryKind';
      id: string;
      name?: string | null;
      nameIt?: string | null;
      nameEn?: string | null;
      contentType?: Types.SharryContentType | null;
    } | null;
  }> | null;
  sharryIndex?: Array<{
    __typename?: 'SharryContentIndices';
    id?: string | null;
    indexType?: string | null;
    wonders?: Array<{
      __typename?: 'Wonder';
      id: string;
      slug?: string | null;
      title?: string | null;
      contentType?: string | null;
      sharrySelection?: Types.SharrySelection | null;
      coverPicture?: {
        __typename?: 'GalleryImage';
        id?: string | null;
        bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
      } | null;
      myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
      sharryKind?: {
        __typename?: 'SharryKind';
        id: string;
        name?: string | null;
        nameIt?: string | null;
        nameEn?: string | null;
        contentType?: Types.SharryContentType | null;
      } | null;
    }> | null;
  }> | null;
  recipeNew?: Array<{ __typename?: 'Recipe'; id: string }> | null;
  mapPicture?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  staticMap?: {
    __typename?: 'Image';
    url?: string | null;
    vw480?: string | null;
    vw768?: string | null;
    vw1024?: string | null;
    id?: string | null;
  } | null;
  paladinUrls?: Array<{
    __typename?: 'CollaborationUrls';
    imageUrl?: string | null;
    redirectUrl?: string | null;
  }> | null;
  attachedDocuments?: Array<{ __typename?: 'AttachedDocument'; id?: string | null }> | null;
  galleryContents?: Array<
    | { __typename?: 'GalleryEmbed'; id?: string | null }
    | {
        __typename?: 'GalleryImage';
        id?: string | null;
      }
  > | null;
  pnrrContent?: {
    __typename?: 'Pnrr';
    id: string;
    text?: string | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  } | null;
};

export type WonderDocumentsFragment = {
  __typename?: 'Wonder';
  id: string;
  slug?: string | null;
  attachedDocuments?: Array<{
    __typename?: 'AttachedDocument';
    id?: string | null;
    name?: string | null;
    url?: string | null;
    mimeType?: string | null;
    kind?: Types.AttachedDocumentAttachmentEnum | null;
  }> | null;
};

export type WonderCollaborationsFragment = {
  __typename?: 'Wonder';
  id: string;
  slug?: string | null;
  collaborations?: Array<{
    __typename?: 'Collaboration';
    collaboratorName?: string | null;
    id: string;
    isPaladin?: boolean | null;
    isFeatured?: boolean | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    collaborationKind?: { __typename?: 'CollaborationKind'; text?: string | null; id: string } | null;
    user?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      slug?: string | null;
      surname?: string | null;
      isSmallOrganisation?: boolean | null;
      anonymised?: boolean | null;
      businessName?: string | null;
      isProGold?: boolean | null;
      role: Types.UserRole;
      sharrylandPartner: boolean;
      image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
    } | null;
  }> | null;
};

export type AdvertisementFragment = {
  __typename?: 'Advertisement';
  id: string;
  backgroundColor?: string | null;
  status?: Types.AdvertisementStatus | null;
  title?: string | null;
  buttonColor?: string | null;
  buttonLabel?: string | null;
  createdAt?: any | null;
  description?: string | null;
  expiredAt?: any | null;
  externalLink?: string | null;
  sort?: number | null;
  layoutType?: Types.AdvertisementLayout | null;
  textColor?: string | null;
  internal?: boolean | null;
  featuredAt?: any | null;
  image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  sharryContents?: Array<
    | { __typename?: 'Event'; id: string; slug?: string | null; title?: string | null }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        title?: string | null;
      }
    | { __typename?: 'Sharry'; id: string; slug?: string | null; title?: string | null }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        title?: string | null;
      }
  > | null;
  owner?: {
    __typename?: 'User';
    id: string;
    anonymised?: boolean | null;
    businessName?: string | null;
    name?: string | null;
    surname?: string | null;
    image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
  } | null;
  logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
};

export type LandEssentialsFragment = { __typename?: 'Land'; id: string; title?: string | null; slug?: string | null };

export type GetWonderQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type GetWonderQuery = {
  __typename?: 'Query';
  sharryContentBySlug?:
    | { __typename?: 'Event' }
    | { __typename?: 'Post' }
    | { __typename?: 'Sharry' }
    | {
        __typename?: 'Wonder';
        id: string;
        showComments?: boolean | null;
        pnrr?: boolean | null;
        originalLanguage?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        featuredAt?: any | null;
        showMaps?: boolean | null;
        address?: string | null;
        audio?: string | null;
        audioDuration?: number | null;
        audioText?: string | null;
        audioSignature?: string | null;
        bookingNotes?: string | null;
        contentType?: string | null;
        hasCustomCover?: boolean | null;
        createdAt?: any | null;
        directions?: string | null;
        elevation?: number | null;
        email?: string | null;
        estimatedDuration?: string | null;
        facebook?: string | null;
        genericContact?: string | null;
        instagram?: string | null;
        whatsapp?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        notes?: string | null;
        openingTime?: string | null;
        paymentNotes?: string | null;
        promoted?: boolean | null;
        requiresBooking?: boolean | null;
        requiresPayment?: boolean | null;
        region?: string | null;
        province?: string | null;
        municipality?: string | null;
        shortProvince?: string | null;
        customProvince?: string | null;
        searchableAddress?: string | null;
        shortAddress?: string | null;
        slug?: string | null;
        subtitle?: string | null;
        showCustomCarousels?: boolean | null;
        showRelatedCarousels?: boolean | null;
        wonderRelatedCarousel?: boolean | null;
        sharryRelatedCarousel?: boolean | null;
        eventRelatedCarousel?: boolean | null;
        userRelatedCarousel?: boolean | null;
        showDirections?: boolean | null;
        suggestedTime?: string | null;
        telephone?: string | null;
        title?: string | null;
        updatedAt?: any | null;
        validatorNotes?: string | null;
        website?: string | null;
        isRecommendation?: boolean | null;
        whyItsSpecialForYou?: string | null;
        status: Types.SharryContentStatus;
        publishedAt?: any | null;
        story?: string | null;
        geographicallyExcludedIds?: Array<string> | null;
        totalCherries?: number | null;
        landIds?: Array<string> | null;
        itineraryNew?: { __typename?: 'Itinerary'; id: string } | null;
        metaTag?: { __typename?: 'MetaTag'; id: string; title?: string | null; description?: string | null } | null;
        sharryKind?: {
          __typename?: 'SharryKind';
          id: string;
          name?: string | null;
          nameIt?: string | null;
          nameEn?: string | null;
          contentType?: Types.SharryContentType | null;
        } | null;
        accessibilityCategories?: Array<{
          __typename?: 'SharryContentAccessibilityCategory';
          id: string;
          suitable?: boolean | null;
          notes?: string | null;
          accessibilityCategory: { __typename?: 'AccessibilityCategory'; id?: string | null; name?: string | null };
        }> | null;
        categories?: Array<{
          __typename?: 'Category';
          id?: string | null;
          name?: string | null;
          normalizedName?: string | null;
          sort?: number | null;
          icon?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        }> | null;
        customCover?: {
          __typename?: 'CustomCover';
          id: string;
          licenseType?: Types.GalleryContentLicenseEnum | null;
          author?: string | null;
          description?: string | null;
          image?: {
            __typename?: 'Image';
            url?: string | null;
            vw480?: string | null;
            vw768?: string | null;
            vw1024?: string | null;
            id?: string | null;
            thumbnail?: string | null;
          } | null;
        } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          licenseType?: Types.GalleryContentLicenseEnum | null;
          author?: string | null;
          description?: string | null;
          bestVersion?: {
            __typename?: 'Image';
            url?: string | null;
            vw480?: string | null;
            vw768?: string | null;
            vw1024?: string | null;
            id?: string | null;
            thumbnail?: string | null;
          } | null;
        } | null;
        creator?: {
          __typename?: 'User';
          id: string;
          anonymised?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          fullname?: string | null;
          email?: string | null;
          isSmallOrganisation?: boolean | null;
          isMe: boolean;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          slug?: string | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          myFollow?: { __typename?: 'Follow'; id: string } | null;
          qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
        } | null;
        hashtags?: Array<{ __typename?: 'Hashtag'; id: string; name: string }> | null;
        owner?: {
          __typename?: 'User';
          id: string;
          anonymised?: boolean | null;
          name?: string | null;
          surname?: string | null;
          businessName?: string | null;
          email?: string | null;
          isSmallOrganisation?: boolean | null;
          isMe: boolean;
          isProGold?: boolean | null;
          role: Types.UserRole;
          sharrylandPartner: boolean;
          slug?: string | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          myFollow?: { __typename?: 'Follow'; id: string } | null;
          qualification?: { __typename?: 'Qualification'; id: string; text?: string | null } | null;
        } | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        visitDuration?: { __typename?: 'VisitDuration'; id: string; text?: string | null } | null;
        originalRecommendation?: { __typename?: 'Wonder'; id: string; slug?: string | null } | null;
        publisher?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          isSmallOrganisation?: boolean | null;
          anonymised?: boolean | null;
          businessName?: string | null;
        } | null;
        services?: Array<{
          __typename?: 'Service';
          id?: string | null;
          name?: string | null;
          icon?: string | null;
        }> | null;
        months?: Array<{ __typename?: 'Month'; id?: string | null; name?: string | null }> | null;
        itineraryIndex?: Array<{
          __typename?: 'Wonder';
          id: string;
          slug?: string | null;
          title?: string | null;
          contentType?: string | null;
          sharrySelection?: Types.SharrySelection | null;
          coverPicture?: {
            __typename?: 'GalleryImage';
            id?: string | null;
            bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
          sharryKind?: {
            __typename?: 'SharryKind';
            id: string;
            name?: string | null;
            nameIt?: string | null;
            nameEn?: string | null;
            contentType?: Types.SharryContentType | null;
          } | null;
        }> | null;
        sharryIndex?: Array<{
          __typename?: 'SharryContentIndices';
          id?: string | null;
          indexType?: string | null;
          wonders?: Array<{
            __typename?: 'Wonder';
            id: string;
            slug?: string | null;
            title?: string | null;
            contentType?: string | null;
            sharrySelection?: Types.SharrySelection | null;
            coverPicture?: {
              __typename?: 'GalleryImage';
              id?: string | null;
              bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
            } | null;
            myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
            sharryKind?: {
              __typename?: 'SharryKind';
              id: string;
              name?: string | null;
              nameIt?: string | null;
              nameEn?: string | null;
              contentType?: Types.SharryContentType | null;
            } | null;
          }> | null;
        }> | null;
        recipeNew?: Array<{ __typename?: 'Recipe'; id: string }> | null;
        mapPicture?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        staticMap?: {
          __typename?: 'Image';
          url?: string | null;
          vw480?: string | null;
          vw768?: string | null;
          vw1024?: string | null;
          id?: string | null;
        } | null;
        paladinUrls?: Array<{
          __typename?: 'CollaborationUrls';
          imageUrl?: string | null;
          redirectUrl?: string | null;
        }> | null;
        attachedDocuments?: Array<{ __typename?: 'AttachedDocument'; id?: string | null }> | null;
        galleryContents?: Array<
          | { __typename?: 'GalleryEmbed'; id?: string | null }
          | {
              __typename?: 'GalleryImage';
              id?: string | null;
            }
        > | null;
        pnrrContent?: {
          __typename?: 'Pnrr';
          id: string;
          text?: string | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | null;
};

export type GetContentTranslatedQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  locale?: Types.InputMaybe<Types.Locale>;
}>;

export type GetContentTranslatedQuery = {
  __typename?: 'Query';
  sharryContentBySlug?:
    | { __typename?: 'Event' }
    | { __typename?: 'Post' }
    | { __typename?: 'Sharry' }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        title?: string | null;
        subtitle?: string | null;
        whyItsSpecialForYou?: string | null;
        story?: string | null;
      }
    | null;
};

export type GetContentAdvertisementsQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type GetContentAdvertisementsQuery = {
  __typename?: 'Query';
  sharryContentBySlug?:
    | {
        __typename?: 'Event';
        id: string;
        slug?: string | null;
        advertisements?: Array<{
          __typename?: 'Advertisement';
          id: string;
          backgroundColor?: string | null;
          status?: Types.AdvertisementStatus | null;
          title?: string | null;
          buttonColor?: string | null;
          buttonLabel?: string | null;
          createdAt?: any | null;
          description?: string | null;
          expiredAt?: any | null;
          externalLink?: string | null;
          sort?: number | null;
          layoutType?: Types.AdvertisementLayout | null;
          textColor?: string | null;
          internal?: boolean | null;
          featuredAt?: any | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          sharryContents?: Array<
            | { __typename?: 'Event'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Post';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
            | { __typename?: 'Sharry'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Wonder';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
          > | null;
          owner?: {
            __typename?: 'User';
            id: string;
            anonymised?: boolean | null;
            businessName?: string | null;
            name?: string | null;
            surname?: string | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        }> | null;
      }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        advertisements?: Array<{
          __typename?: 'Advertisement';
          id: string;
          backgroundColor?: string | null;
          status?: Types.AdvertisementStatus | null;
          title?: string | null;
          buttonColor?: string | null;
          buttonLabel?: string | null;
          createdAt?: any | null;
          description?: string | null;
          expiredAt?: any | null;
          externalLink?: string | null;
          sort?: number | null;
          layoutType?: Types.AdvertisementLayout | null;
          textColor?: string | null;
          internal?: boolean | null;
          featuredAt?: any | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          sharryContents?: Array<
            | { __typename?: 'Event'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Post';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
            | { __typename?: 'Sharry'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Wonder';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
          > | null;
          owner?: {
            __typename?: 'User';
            id: string;
            anonymised?: boolean | null;
            businessName?: string | null;
            name?: string | null;
            surname?: string | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        }> | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        slug?: string | null;
        advertisements?: Array<{
          __typename?: 'Advertisement';
          id: string;
          backgroundColor?: string | null;
          status?: Types.AdvertisementStatus | null;
          title?: string | null;
          buttonColor?: string | null;
          buttonLabel?: string | null;
          createdAt?: any | null;
          description?: string | null;
          expiredAt?: any | null;
          externalLink?: string | null;
          sort?: number | null;
          layoutType?: Types.AdvertisementLayout | null;
          textColor?: string | null;
          internal?: boolean | null;
          featuredAt?: any | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          sharryContents?: Array<
            | { __typename?: 'Event'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Post';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
            | { __typename?: 'Sharry'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Wonder';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
          > | null;
          owner?: {
            __typename?: 'User';
            id: string;
            anonymised?: boolean | null;
            businessName?: string | null;
            name?: string | null;
            surname?: string | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        }> | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        advertisements?: Array<{
          __typename?: 'Advertisement';
          id: string;
          backgroundColor?: string | null;
          status?: Types.AdvertisementStatus | null;
          title?: string | null;
          buttonColor?: string | null;
          buttonLabel?: string | null;
          createdAt?: any | null;
          description?: string | null;
          expiredAt?: any | null;
          externalLink?: string | null;
          sort?: number | null;
          layoutType?: Types.AdvertisementLayout | null;
          textColor?: string | null;
          internal?: boolean | null;
          featuredAt?: any | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          sharryContents?: Array<
            | { __typename?: 'Event'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Post';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
            | { __typename?: 'Sharry'; id: string; slug?: string | null; title?: string | null }
            | {
                __typename?: 'Wonder';
                id: string;
                slug?: string | null;
                title?: string | null;
              }
          > | null;
          owner?: {
            __typename?: 'User';
            id: string;
            anonymised?: boolean | null;
            businessName?: string | null;
            name?: string | null;
            surname?: string | null;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
          logo?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        }> | null;
      }
    | null;
};

export type SharryContentMyLikeQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type SharryContentMyLikeQuery = {
  __typename?: 'Query';
  sharryContentBySlug?:
    | {
        __typename?: 'Event';
        id: string;
        slug?: string | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
      }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        slug?: string | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        myLikeItineraryIndex?: Array<{
          __typename?: 'Wonder';
          id: string;
          myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        }> | null;
        myFavourite?: { __typename?: 'ContentLike'; id: string } | null;
        myFollow?: { __typename?: 'Follow'; id: string } | null;
      }
    | null;
};

export type GetRelatedPostsQueryVariables = Types.Exact<{
  coordinates: Types.Coordinates;
}>;

export type GetRelatedPostsQuery = {
  __typename?: 'Query';
  allSharryContents?: Array<
    | {
        __typename?: 'Event';
        id: string;
        slug?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        totalReviewCount?: number | null;
        contentType?: string | null;
        title?: string | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Post';
        id: string;
        slug?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        totalReviewCount?: number | null;
        contentType?: string | null;
        title?: string | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Sharry';
        id: string;
        slug?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        totalReviewCount?: number | null;
        contentType?: string | null;
        title?: string | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        sharrySelection?: Types.SharrySelection | null;
        totalReviewCount?: number | null;
        contentType?: string | null;
        title?: string | null;
        sharryKind?: { __typename?: 'SharryKind'; id: string; name?: string | null } | null;
        coverPicture?: {
          __typename?: 'GalleryImage';
          id?: string | null;
          bestVersion?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
        } | null;
      }
  > | null;
};

export type LandEssentialsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type LandEssentialsQuery = {
  __typename?: 'Query';
  land?: { __typename?: 'Land'; id: string; title?: string | null; slug?: string | null } | null;
};

export type WonderDocumentsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type WonderDocumentsQuery = {
  __typename?: 'Query';
  sharryContent?:
    | { __typename?: 'Event' }
    | { __typename?: 'Post' }
    | { __typename?: 'Sharry' }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        attachedDocuments?: Array<{
          __typename?: 'AttachedDocument';
          id?: string | null;
          name?: string | null;
          url?: string | null;
          mimeType?: string | null;
          kind?: Types.AttachedDocumentAttachmentEnum | null;
        }> | null;
      }
    | null;
};

export type WonderCollaborationsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type WonderCollaborationsQuery = {
  __typename?: 'Query';
  sharryContent?:
    | { __typename?: 'Event' }
    | { __typename?: 'Post' }
    | { __typename?: 'Sharry' }
    | {
        __typename?: 'Wonder';
        id: string;
        slug?: string | null;
        collaborations?: Array<{
          __typename?: 'Collaboration';
          collaboratorName?: string | null;
          id: string;
          isPaladin?: boolean | null;
          isFeatured?: boolean | null;
          image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          collaborationKind?: { __typename?: 'CollaborationKind'; text?: string | null; id: string } | null;
          user?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            slug?: string | null;
            surname?: string | null;
            isSmallOrganisation?: boolean | null;
            anonymised?: boolean | null;
            businessName?: string | null;
            isProGold?: boolean | null;
            role: Types.UserRole;
            sharrylandPartner: boolean;
            image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
          } | null;
        }> | null;
      }
    | null;
};

export const WonderFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Wonder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pnrr' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'itineraryNew' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metaTag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'originalLanguage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameEn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featuredAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showMaps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessibilityCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suitable' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessibilityCategory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audio' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'audioDuration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audioText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'audioSignature' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingNotes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sort' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '128x128', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasCustomCover' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customCover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'description' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw480' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '500x500', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw768' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '800x800', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw1024' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1024x1024', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1280x1280', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'thumbnail' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'description' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw480' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '500x500', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw768' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '800x800', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw1024' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1024x1024', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1280x1280', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'thumbnail' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '300x300', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'email' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymised' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMe' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFollow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualification' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'directions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elevation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'estimatedDuration' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'genericContact' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hashtags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whatsapp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openingTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '300x300', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isMe' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFollow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualification' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentNotes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'promoted' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresBooking' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiresPayment' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortProvince' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customProvince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchableAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showCustomCarousels' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showRelatedCarousels' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wonderRelatedCarousel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharryRelatedCarousel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventRelatedCarousel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userRelatedCarousel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showDirections' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'telephone' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'validatorNotes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visitDuration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isRecommendation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'whyItsSpecialForYou' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originalRecommendation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publisher' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'anonymised' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'services' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'months' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'itineraryIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverPicture' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bestVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '300x300', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFavourite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharryKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameEn' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'indexType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wonders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverPicture' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bestVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'size' },
                                        value: { kind: 'StringValue', value: '300x300', block: false },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFavourite' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'story' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'geographicallyExcludedIds' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipeNew' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mapPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staticMap' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw480' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '700x700', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw768' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '840x840', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw1024' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '1200x1200', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '1200x1200', block: false },
                    },
                  ],
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCherries' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landIds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deployed' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paladinUrls' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'redirectUrl' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachedDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pnrrContent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '300x300', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WonderDocumentsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WonderDocuments' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachedDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mimeType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WonderCollaborationsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WonderCollaborations' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaborations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collaborationKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'id' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'collaboratorName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'id' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isPaladin' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isFeatured' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AdvertisementFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Advertisement' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Advertisement' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expiredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalLink' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layoutType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internal' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'anonymised' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '160x160', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const LandEssentialsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LandEssentials' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Land' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetWonderDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getWonder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContentBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Wonder' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Wonder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showComments' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pnrr' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'itineraryNew' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metaTag' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'originalLanguage' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryKind' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameEn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featuredAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showMaps' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessibilityCategories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'suitable' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accessibilityCategory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'address' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audio' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'audioDuration' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audioText' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'audioSignature' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingNotes' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'categories' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sort' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'icon' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '128x128', block: false },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hasCustomCover' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customCover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'description' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw480' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '500x500', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw768' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '800x800', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw1024' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1024x1024', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1280x1280', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'thumbnail' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'coverPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'licenseType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'author' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'description' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bestVersion' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw480' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '500x500', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw768' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '800x800', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'vw1024' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1024x1024', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '1280x1280', block: false },
                          },
                        ],
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'thumbnail' },
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'convert' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '300x300', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'email' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymised' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isMe' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isProGold' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharrylandPartner' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFollow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualification' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'directions' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'elevation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'estimatedDuration' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'genericContact' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hashtags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'whatsapp' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'longitude' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'openingTime' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '300x300', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isMe' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFollow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'qualification' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myFavourite' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'paymentNotes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'promoted' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requiresBooking' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requiresPayment' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'region' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'province' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'municipality' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shortProvince' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customProvince' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchableAddress' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'shortAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showCustomCarousels' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'showRelatedCarousels' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'wonderRelatedCarousel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sharryRelatedCarousel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventRelatedCarousel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userRelatedCarousel' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'showDirections' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedTime' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'telephone' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'validatorNotes' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'visitDuration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'website' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isRecommendation' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'whyItsSpecialForYou' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'originalRecommendation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publisher' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isSmallOrganisation' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'anonymised' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'services' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'months' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'itineraryIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverPicture' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bestVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '300x300', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFavourite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'title' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharryKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameEn' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'indexType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'wonders' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coverPicture' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bestVersion' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'id' },
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'size' },
                                        value: { kind: 'StringValue', value: '300x300', block: false },
                                      },
                                    ],
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFavourite' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharryKind' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameIt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameEn' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'story' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'geographicallyExcludedIds' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipeNew' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mapPicture' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staticMap' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw480' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '700x700', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw768' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '840x840', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'vw1024' },
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '1200x1200', block: false },
                    },
                  ],
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'url' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: { kind: 'StringValue', value: '1200x1200', block: false },
                    },
                  ],
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'totalCherries' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landIds' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deployed' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paladinUrls' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'redirectUrl' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachedDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'galleryContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pnrrContent' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '300x300', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetWonderGQL extends Apollo.Query<GetWonderQuery, GetWonderQueryVariables> {
  document = GetWonderDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetContentTranslatedDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getContentTranslated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Locale' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContentBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'locale' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'locale' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtitle' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'whyItsSpecialForYou' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'story' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetContentTranslatedGQL extends Apollo.Query<
  GetContentTranslatedQuery,
  GetContentTranslatedQueryVariables
> {
  document = GetContentTranslatedDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetContentAdvertisementsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getContentAdvertisements' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContentBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'advertisements' },
                  name: { kind: 'Name', value: 'visibleAdvertisements' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Advertisement' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Advertisement' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Advertisement' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'backgroundColor' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'buttonColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buttonLabel' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'description' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expiredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'externalLink' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'image' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sort' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'layoutType' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'textColor' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internal' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'featuredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'owner' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'anonymised' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '160x160', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'url' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetContentAdvertisementsGQL extends Apollo.Query<
  GetContentAdvertisementsQuery,
  GetContentAdvertisementsQueryVariables
> {
  document = GetContentAdvertisementsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const SharryContentMyLikeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sharryContentMyLike' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContentBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFavourite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'myFollow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'myLikeItineraryIndex' },
                        name: { kind: 'Name', value: 'itineraryIndex' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'myFavourite' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class SharryContentMyLikeGQL extends Apollo.Query<SharryContentMyLikeQuery, SharryContentMyLikeQueryVariables> {
  document = SharryContentMyLikeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetRelatedPostsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRelatedPosts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'coordinates' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Coordinates' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allSharryContents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'IntValue', value: '2' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'and' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'query' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'field' },
                                      value: { kind: 'StringValue', value: 'contentType', block: false },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'comparator' },
                                      value: { kind: 'EnumValue', value: 'eq' },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'value' },
                                      value: { kind: 'StringValue', value: 'post', block: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'query' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'field' },
                                      value: { kind: 'StringValue', value: 'status', block: false },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'comparator' },
                                      value: { kind: 'EnumValue', value: 'eq' },
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'value' },
                                      value: { kind: 'StringValue', value: 'published', block: false },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includePosts' },
                value: { kind: 'BooleanValue', value: true },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'near' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'coordinates' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'coordinates' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'maxDistance' },
                      value: { kind: 'IntValue', value: '50' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'count' },
                value: { kind: 'BooleanValue', value: true },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'sharrySelection' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sharryKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'name' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalReviewCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contentType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coverPicture' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bestVersion' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '80x80', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetRelatedPostsGQL extends Apollo.Query<GetRelatedPostsQuery, GetRelatedPostsQueryVariables> {
  document = GetRelatedPostsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const LandEssentialsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'landEssentials' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'land' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LandEssentials' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LandEssentials' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Land' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class LandEssentialsGQL extends Apollo.Query<LandEssentialsQuery, LandEssentialsQueryVariables> {
  document = LandEssentialsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const WonderDocumentsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'wonderDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WonderDocuments' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WonderDocuments' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachedDocuments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'name' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mimeType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class WonderDocumentsGQL extends Apollo.Query<WonderDocumentsQuery, WonderDocumentsQueryVariables> {
  document = WonderDocumentsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const WonderCollaborationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'wonderCollaborations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sharryContent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WonderCollaborations' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WonderCollaborations' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Wonder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'slug' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'collaborations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'image' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'id' },
                        name: { kind: 'Name', value: 'url' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'url' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: { kind: 'StringValue', value: '600x600', block: false },
                          },
                        ],
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'collaborationKind' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'id' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'collaboratorName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'id' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isPaladin' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isFeatured' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'surname' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class WonderCollaborationsGQL extends Apollo.Query<
  WonderCollaborationsQuery,
  WonderCollaborationsQueryVariables
> {
  document = WonderCollaborationsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
